<template>
  <el-input
    :type="openeye ? 'text' : 'password'"
    @input="input"
    :value="value"
    :placeholder="placeholder"
    clearable
    :prefix-icon="prefixIcon"
    :disabled="readonly"
  >
    <i
      :class="openeye ? 'ri-eye-fill' : 'ri-eye-off-fill'"
      slot="suffix"
      @click="openeye = !openeye"
      style="cursor: pointer"
    ></i>
  </el-input>
</template>

<script>
export default {
  props: {
    value: {},
    placeholder: {},
    prefixIcon: {},
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openeye: false,
    };
  },
  methods: {
    input(e) {
      this.$emit("input", e);
    },
  },
};
</script>

